import { createContext, useContext } from 'react';

export type AuthStatus = 'initializing' | 'signedOut' | 'signingIn' | 'signedIn' | 'error';

export type AuthState = {
  status: AuthStatus;
  mode: 'msal' | 'dev';
  /** Anzeigename aus dem Login (vor /me). */
  accountLabel: string | null;
  error: string | null;
  loginDev: (email: string) => Promise<void>;
  loginMsal: () => Promise<void>;
  logout: () => Promise<void>;
};

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth außerhalb des AuthProvider');
  return ctx;
}
